/* SET STATE */
export const SET_STATE_LABREQUESTASSIGNMENT = "SET_STATE_LABREQUESTASSIGNMENT"

/* LABREQUESTASSIGNMENTS */
export const GET_LABREQUESTASSIGNMENTS = "GET_LABREQUESTASSIGNMENTS"
export const GET_LABREQUESTASSIGNMENTS_SUCCESS = "GET_LABREQUESTASSIGNMENTS_SUCCESS"
export const GET_LABREQUESTASSIGNMENTS_FAIL = "GET_LABREQUESTASSIGNMENTS_FAIL"

/* LABREQUESTASSIGNMENT */
export const GET_LABREQUESTASSIGNMENT = "GET_LABREQUESTASSIGNMENT"
export const GET_LABREQUESTASSIGNMENT_SUCCESS = "GET_LABREQUESTASSIGNMENT_SUCCESS"
export const GET_LABREQUESTASSIGNMENT_FAIL = "GET_LABREQUESTASSIGNMENT_FAIL"

/**
 * ADD LABREQUESTASSIGNMENT
 */
 export const ADD_NEW_LABREQUESTASSIGNMENT = "ADD_NEW_LABREQUESTASSIGNMENT"
 export const ADD_LABREQUESTASSIGNMENT_SUCCESS = "ADD_LABREQUESTASSIGNMENT_SUCCESS"
 export const ADD_LABREQUESTASSIGNMENT_FAIL = "ADD_LABREQUESTASSIGNMENT_FAIL"

 /**
 * UPDATE LABREQUESTASSIGNMENT
 */
export const UPDATE_LABREQUESTASSIGNMENT = "UPDATE_LABREQUESTASSIGNMENT"
export const UPDATE_LABREQUESTASSIGNMENT_SUCCESS = "UPDATE_LABREQUESTASSIGNMENT_SUCCESS"
export const UPDATE_LABREQUESTASSIGNMENT_FAIL = "UPDATE_LABREQUESTASSIGNMENT_FAIL"

/**
 * DELETE LABREQUESTASSIGNMENT
 */
export const DELETE_LABREQUESTASSIGNMENT = "DELETE_LABREQUESTASSIGNMENT"
export const DELETE_LABREQUESTASSIGNMENT_SUCCESS = "DELETE_LABREQUESTASSIGNMENT_SUCCESS"
export const DELETE_LABREQUESTASSIGNMENT_FAIL = "DELETE_LABREQUESTASSIGNMENT_FAIL"
